import { useSelector } from 'react-redux';
import { selectActiveStatusUpdate } from 'data/status-updates';

export const useActiveStatUpdateCCs = (): string[] => {
  const activeStatusUpdate = useSelector(selectActiveStatusUpdate);
  const { ccUsers = [] } = activeStatusUpdate || {};

  return ccUsers.map(({ emailId }) => emailId);
};
